import React, { Component } from "react";
import PieChart from "app/components/charts/PieChart";
import { logActivity } from "../../redux/api/loggingAPI";
import { UserActivityConstants } from "api/UserActivityConstants";

class GenderJobCounts extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}

  	}

	// handleHover = (genderName) => {
	// 	logActivity({
	// 		screen: UserActivityConstants.SCREEN3.NAME,
	// 		action : UserActivityConstants.SCREEN3.ACTIONS.HOVER.GENDER,
	// 		action_target: genderName,
	// 		action_type : UserActivityConstants.ACTION_TYPES.HOVER
	// 	})
	// }
     

	render() {
		let industryType = this.props.industryType;
		let totalCount = 0;
		this.props.pieData.map(e => {
			totalCount += e.y;
		});
		return (
			<div className="graph-wrapper screen-left-graph-container">
				<div className="graph-title-container">
				</div>
				<div className="graph-screen graph-screen3">
                    <div className="graph-title graph-title-2" style={{ marginTop: "20px", marginBottom: "40px",  marginLeft: "150px" }}>Gender</div>
                    <PieChart 
						height={"535px"} 
						data={this.props.pieData}
						tooltipFormatter={
							function() {
								const gender = this.point.name;
								const value = this.point.y;
								const percent = parseFloat(((value/totalCount)*100).toFixed(2));
								let tooltip = 'Industry Description: <b>' + industryType + '</b><br>';
								tooltip += 'Gender: <b>'+gender+'</b><br>';
								tooltip += 'Count: <b>'+value.toLocaleString("en-US")+'</b>' + ' ( ' + percent + '% )';
								return tooltip;
							}}
						
						// onHover={(genderName) => {
						// 	this.handleHover(genderName)
						// }}
					/>
				</div>
			</div>
		);
	}
}


export default GenderJobCounts;
